// Tiny history-API router. Every feature gets its own URL so links are
// shareable and bookmarkable. `data-link` on any <a> means "intercept this
// click and navigate without a full reload".

import { Dashboard } from './pages/Dashboard.js';
import { VocabIndex } from './pages/VocabIndex.js';
import { VocabCategory } from './pages/VocabCategory.js';
import { GrammarPlayground } from './pages/GrammarPlayground.js';
import { Flashcards } from './pages/Flashcards.js';
import { NotFound } from './pages/NotFound.js';
import { updateSidebar } from './components/Sidebar.js';

const routes = [
  { path: /^\/$/,                          page: Dashboard,         key: '/dashboard' },
  { path: /^\/dashboard$/,                 page: Dashboard,         key: '/dashboard' },
  { path: /^\/vocab$/,                     page: VocabIndex,        key: '/vocab' },
  { path: /^\/vocab\/([a-z-]+)$/,          page: VocabCategory,     key: '/vocab', params: ['category'] },
  { path: /^\/grammar$/,                   page: GrammarPlayground, key: '/grammar/building-blocks' },
  { path: /^\/grammar\/building-blocks$/,  page: GrammarPlayground, key: '/grammar/building-blocks' },
  { path: /^\/flashcards$/,                page: Flashcards,        key: '/flashcards' },
];

function render() {
  const path = window.location.pathname || '/';
  const view = document.getElementById('view');
  if (!view) return;

  let matched = null;
  const params = {};
  for (const route of routes) {
    const m = path.match(route.path);
    if (m) {
      matched = route;
      (route.params || []).forEach((key, i) => { params[key] = m[i + 1]; });
      break;
    }
  }

  view.innerHTML = '';
  if (matched) matched.page(view, params);
  else NotFound(view);

  // Replay the fade-in animation on every navigation.
  view.classList.remove('animate-fade-in');
  void view.offsetWidth;
  view.classList.add('animate-fade-in');

  updateSidebar(matched?.key || path);
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

export function navigate(to) {
  if (window.location.pathname === to) return;
  window.history.pushState({}, '', to);
  render();
}

export function initRouter() {
  document.addEventListener('click', e => {
    const a = e.target.closest('a[data-link]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href || href.startsWith('http')) return;
    e.preventDefault();
    navigate(href);
  });
  window.addEventListener('popstate', render);
  render();
}
